module.exports = __webpack_public_path__ + "static/media/drag.55647028.png";